import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader";
import { Theme, themeColorSet, ThemedPressable, ThemedText, ThemedView } from "@app/theme";
import { ScrollView,Image } from "react-native";
import { INSTANT_IMG,GROW_IMG,RUPEE_IMG } from "../Dashboard/constant";
import Button from "@app/sharedComponents/Button/Button";
import LoanRenewalLogo1 from "../../../assets/Icons/LoanRenewalLogo1";
import {CaretRight} from '@sharedComponents/Icons/Icons';
import ROUTE from "@app/navigationApp/routes";
import BottomSheetContainer from "@app/sharedComponents/Bottomsheet/Bottomsheet";
import Question from '../../../assets/Icons/QuestionIcon';
import { useState } from "react";
import RenewBreakUp from "./RenewBreakUp";
import HowRenewWork from "./HowRenewWork";
import { useAppSelector } from "@app/store/hooks";
import { WarningCircle } from '@app/sharedComponents/Icons/Icons';
import { formatIndianCurrency } from "@app/utils/utility";
import { useTheme } from "@shopify/restyle";
import CircleQuestion from "@app/assets/svg/CircleQuestion";
import PledgeIconNew from "@app/assets/svg/PledgeIconNew";
import GrowthIcon from "@app/assets/svg/GrowthIcon";
import MoneyIcon from "@app/assets/svg/MoneyIcon";
import LightningIcon from "@app/assets/svg/LightningIcon";

const RenewLoan = ({navigation,route}) => {
    const daysToRenewal = route?.params?.daysToRenewal;
    const [isBottomSheetVisible, setIsBottomSheetVisible] = useState(false);
    const [bottomSheetType, setBottomSheetType] = useState(null);
    const creditInfo = useAppSelector((state) => state.auth.creditDetails);
    const userDetails = useAppSelector((state) => state.auth.userDetails);
    const faqData = useAppSelector((state)=>state?.firebaseParams?.faqData);
    const {colors} = useTheme<Theme>()

    const parsedFaqData = JSON.parse(faqData||"{}");
    const renewFaqParams = {
        data:'',
        item:''
    }
    parsedFaqData?.faqData?.forEach((item,index) => {
        if (item.id === 'RENEWAL') {
            renewFaqParams.item = item?.cards;
            renewFaqParams.title = item?.title;
        }
    });
    const openBottomSheet = (type) =>{
        setBottomSheetType(type);
        setIsBottomSheetVisible(true);
    }

    const closeBottomSheet = () =>{
        setIsBottomSheetVisible(false);
        setTimeout(()=>{
            setBottomSheetType(null)
        },700)
    }
    return(
        <>
        <PageHeaders pageName={route?.name} label={"Renew Loan"} navigation={navigation}/>
        <ScrollView style={{backgroundColor:themeColorSet["bg-surface-page"],flex:1}}>
        <ThemedView flexDirection="row" px="lg" py="xs" backgroundColor="bg-fill-error" alignItems="center" mt="2xl">
                    <WarningCircle weight="fill" size={16} color={themeColorSet["icon-error"]} />
                    <ThemedText ml="sm" color="text-error" variant="b5r" textTransform="uppercase">{daysToRenewal} days remaining to renew your loan</ThemedText>
                </ThemedView>
            <ThemedView backgroundColor="bg-fill-primary" p="lg" mb="lg" borderBottomWidth={1} borderColor="border-primary">
                <ThemedView backgroundColor="bg-surface-primary" borderWidth={1} borderColor="border-primary" borderRadius="md" p="lg" alignItems="center" flexDirection="row" mb="lg" >
                    {/* <Image source={{uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/pledge_assets.png"}} style={{width:42,height:42}} /> */}
                    <PledgeIconNew bgColor={colors['bg-fill-emphasis-primary-1']} color1={colors['icon-action-primary']} color2={colors['icon-emphasis-primary']}/>
                    <ThemedView justifyContent="center" ml="lg">
                        <ThemedText variant="b3r" color="text-secondary" >Credit limit</ThemedText>
                        <ThemedView flexDirection="row" alignItems="center">
                            <ThemedText variant="l2" color="text-primary">₹</ThemedText>
                            <ThemedText variant="h2b" color="text-primary">{formatIndianCurrency(creditInfo?.availableCreditAmount)}</ThemedText>
                        </ThemedView>
                    </ThemedView>
                </ThemedView>
                <Button label="Renew now" size="MD" type="SOLID" handlePress={()=>{navigation?.navigate(ROUTE.VERIFY_RENEW_LOAN,{daysToRenewal})}}  />
                <ThemedText mb="lg" mt="2xl" variant="b2s" color="text-primary">
                    Why renew your loan?
                </ThemedText>
                <ThemedView flexDirection="row" alignItems="center">
                    {/* <Image source={{uri:INSTANT_IMG}} style={{width:24,height:24}} /> */}
                    <LightningIcon bgColor={colors['bg-fill-emphasis-secondary']} color={colors['icon-emphasis-secondary']} size={24}/>
                    <ThemedText variant="b4r" color="text-primary" ml="sm">
                    Continued access to instant funds
                    </ThemedText>
                </ThemedView>
                <ThemedView flexDirection="row" alignItems="center" my="lg">
                    <MoneyIcon bgColor={colors['bg-fill-emphasis-secondary']} color={colors['icon-emphasis-secondary']} size={24}/>
                    <ThemedText variant="b4r" color="text-primary" ml="sm">
                    Avoid repayment of outstanding amount
                    </ThemedText>
                </ThemedView>
                <ThemedView flexDirection="row" alignItems="center">
                    <GrowthIcon bgColor={colors['bg-fill-emphasis-secondary']} color={colors['icon-emphasis-secondary']} size={24}/>
                    <ThemedText variant="b4r" color="text-primary" ml="sm">
                    Let your portfolio grow & meet long term goals 
                    </ThemedText>
                </ThemedView>

            </ThemedView>
            <ThemedView my="lg" borderTopWidth={1} borderColor="border-primary" borderBottomWidth={1} backgroundColor="bg-fill-primary">
                <ThemedPressable onPress={()=>openBottomSheet("HOW_RENEW_WORK")} flexDirection="row" alignItems="center" justifyContent="space-between" p="lg">
                    <ThemedView flexDirection="row" alignItems="center">
                        <LoanRenewalLogo1 color={themeColorSet["icon-secondary"]}/>
                        <ThemedText variant="b3m" color="text-primary" paddingLeft='xs'>See how renewal works</ThemedText>
                    </ThemedView>
                    <CaretRight size={16} color={colors['icon-primary']}/>
                </ThemedPressable>
                <ThemedPressable onPress={()=>openBottomSheet("RENEWAL_BREAKUP")} flexDirection="row" alignItems="center" justifyContent="space-between" p="lg"  borderTopWidth={1} borderColor="border-primary" borderBottomWidth={1}>
                    <ThemedView flexDirection="row" alignItems="center">
                        <LoanRenewalLogo1 color={themeColorSet["icon-secondary"]}/>
                        <ThemedText variant="b3m" color="text-primary" paddingLeft='xs'>Renewal fee and other details</ThemedText>
                    </ThemedView>
                    <CaretRight size={16} color={colors['icon-primary']}/>
                </ThemedPressable>
                <ThemedPressable onPress={()=>navigation.navigate(ROUTE.FAQ_SCREEN_REVAMP,{...renewFaqParams})} flexDirection="row" alignItems="center" justifyContent="space-between" p="lg">
                    <ThemedView flexDirection="row" alignItems="center">
                        {/* <Question size={20} color={themeColorSet["icon-secondary"]} /> */}
                        <CircleQuestion color={themeColorSet["icon-secondary"]}/>
                        <ThemedText variant="b3m" color="text-primary" ml="xs" paddingLeft='xs'>Frequently asked questions</ThemedText>
                    </ThemedView>
                    <CaretRight size={16} color={colors['icon-primary']}/>
                </ThemedPressable>
            </ThemedView>
        </ScrollView>
        <BottomSheetContainer
            isVisible={isBottomSheetVisible}
            close={closeBottomSheet}
            closeOnBackdropPress={true}
            borderTopRightRadius={10}
            borderTopLeftRadius={10}
        >
        {bottomSheetType==="HOW_RENEW_WORK" && <HowRenewWork closeBottomSheet={closeBottomSheet}/>}
        {bottomSheetType==="RENEWAL_BREAKUP" && <RenewBreakUp closeBottomSheet={closeBottomSheet} accountId={userDetails?.linkedBorrowerAccounts[0]?.accountId} />}
        </BottomSheetContainer>
        </>
    )

}
export default RenewLoan;